import React from 'react';
import Section from '../components/Section';

const OurValues = () => {
    return (
        <Section>
            <h1>Our Values</h1>
            <p>
                At HART ÉLÉGANCE, we believe in the power of craftsmanship and quality. Our creations are not just fashion items; they are a testament to the artistry and dedication of our skilled artisans.
            </p>
            <h2>Craftsmanship</h2>
            <p>
                Each piece is meticulously crafted, ensuring that every stitch reflects our commitment to excellence.
            </p>
            <h2>Quality</h2>
            <p>
                We source only the finest materials, guaranteeing that our products are not only beautiful but also durable.
            </p>
            <h2>Sustainable Elegance</h2>
            <p>
                We are dedicated to sustainable practices, creating timeless pieces that respect both the environment and the art of fashion.
            </p>
            <h2>Environmental Respect</h2>
            <p>
                Our commitment to the planet drives us to minimize waste and embrace eco-friendly processes in every aspect of our production.
            </p>
        </Section>
    );
};

export default OurValues;